import { render, staticRenderFns } from "./tick.vue?vue&type=template&id=28b54e99&"
import script from "./tick.vue?vue&type=script&lang=ts&"
export * from "./tick.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports